const CH_CENTER = {
  lat: 46.8182,
  lng: 8.2275,
}

const DEFAULT_ZOOM = 7

export const BASE_MAP_OPTIONS = {
  center: CH_CENTER,
  fullscreenControl: false,
  streetViewControl: false,
  version: 'weekly',
  zoom: DEFAULT_ZOOM,
}

export const DEFAULT_COUNTRY = 'CH'

export const NEARBY_SEARCH_RADIUS = 150

export const PLACE_ZOOM = 18

export const PLACE_FIELDS = [
  'address_component',
  'formatted_address',
  'formatted_phone_number',
  'international_phone_number',
  'name',
  'place_id',
  'price_level',
]

export const RESULT_PLACE_TYPES_BLACKLIST = [
  'administrative_area_level_1',
  'administrative_area_level_2',
  'administrative_area_level_3',
  'administrative_area_level_4',
  'administrative_area_level_5',
  'archipelago',
  'colloquial_area',
  'continent',
  'country',
  // 'establishment',
  // 'finance',
  'floor',
  // 'food',
  'general_contractor',
  'geocode',
  // 'health',
  'intersection',
  'landmark',
  'locality',
  'natural_feature',
  'neighborhood',
  // 'place_of_worship',
  'plus_code',
  // 'point_of_interest',
  'political',
  'post_box',
  // 'postal_code',
  // 'postal_code_prefix',
  // 'postal_code_suffix',
  // 'postal_town',
  // 'premise',
  // 'room',
  'route',
  // 'street_address',
  // 'street_number',
  'sublocality',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality_level_3',
  'sublocality_level_4',
  'sublocality_level_5',
  'subpremise',
  'town_square',
]
